module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA20lEQVR4AWOgC3jMJU4kQtfwVFr9XWbh51nz36XlPZVQJaDhtX/k39dv/v///+v6zU/9Uz9NmPbK0RunhmcqBv8+fwGq/rJ4xWNeKYj0MyW95+pGIC6mhg9VjUDVfz9+fCKmhGzkK//IL3MXAd2JruHzlFkgx1y8jKz6mbrRj/2HgOLvckowbKioB9nw7v0TARkUG/wigP5BtwESPn9evATq+TRxOlz1E3Hlp/JaWPwANczF78/TZ0A9Pw4c/lDbAkQvzBwIxYOE6tu4NKDSN9HJEN+jIdJjelACAAeh1ODszlZIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TR.png
// module id = 1285
// module chunks = 0